export const InklineKey = "inkline";
export const InklineIconsKey = "inklineIcons";
export const InklineModalKey = "inklineModal";
export const InklineToastKey = "inklineToast";
export const ButtonGroupKey = "ButtonGroup";
export const CheckboxGroupKey = "CheckboxGroup";
export const CollapsibleKey = "Collapsible";
export const DropdownKey = "Dropdown";
export const FormKey = "Form";
export const FormGroupKey = "FormGroup";
export const NavKey = "Nav";
export const NavbarKey = "Navbar";
export const ProgressKey = "Progress";
export const RadioGroupKey = "RadioGroup";
export const SelectKey = "Select";
export const SidebarKey = "Sidebar";
export const TabsKey = "Tabs";
